"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationDetailsLayout = exports.LocationDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_lang_1 = require("../../hooks/use-lang");
var format_number_1 = require("../../utils/format-number");
var use_entities_1 = require("../../hooks/use-entities");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var main_aside_1 = require("../elements/main-aside");
var entity_value_1 = require("./entity-value");
var link_1 = require("../elements/link");
var entity_link_value_1 = require("./entity-link-value");
var entity_list_1 = require("./entity-list");
var indicator_value_table_1 = require("./indicator-value-table");
var quote_row_1 = require("./quote-row");
var lodash_1 = require("lodash");
var entity_list_section_1 = require("./entity-list-section");
var grid_1 = require("../elements/grid");
var link_value_1 = require("./link-value");
var file_asset_value_1 = require("./file-asset-value");
exports.LocationDetailsLayoutDefaultProps = {};
// -------- Styles -------->
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", ";\n\n    &:first-child {\n      padding-top: ", ";\n    }\n  "], ["\n    padding: ", " ", " ", ";\n    ", ";\n\n    &:first-child {\n      padding-top: ", ";\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.H_DOT_BG_END(), theme_1.theme.UNIT(3))
});
var TableStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: -", ";\n    margin-bottom: ", ";\n    max-width: 600px;\n  "], ["\n    margin-top: -", ";\n    margin-bottom: ", ";\n    max-width: 600px;\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", ";\n  "], ["\n    padding: ", " ", " ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.H_DOT_BG_END())
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "], ["\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "])), theme_1.theme.UNIT(2))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Table: (0, styled_components_1.default)(indicator_value_table_1.IndicatorValueTable)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), TableStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
var LocationDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    banner = props.banner;
  var t = (0, use_lang_1.useLang)();
  var entities = (0, use_entities_1.useEntities)();
  var definition = entities.Location;
  var chapter = entity.chapter,
    country = entity.country,
    _a = entity.files,
    files = _a === void 0 ? [] : _a,
    _b = entity.impactResults,
    impactResults = _b === void 0 ? [] : _b,
    _c = entity.quotes,
    quotes = _c === void 0 ? [] : _c,
    population = entity.population,
    description = entity.description,
    populationMale = entity.populationMale,
    populationFemale = entity.populationFemale,
    populationCity = entity.populationCity,
    areaInSquareKm = entity.areaInSquareKm,
    densityPerSquareKm = entity.densityPerSquareKm,
    medianAge = entity.medianAge,
    age0To19 = entity.age0To19,
    age20To49 = entity.age20To49,
    age50Plus = entity.age50Plus,
    gdp = entity.gdp,
    _d = entity.people,
    people = _d === void 0 ? [] : _d,
    _e = entity.organisations,
    organisations = _e === void 0 ? [] : _e,
    _f = entity.links,
    links = _f === void 0 ? [] : _f,
    _g = entity.feedEntries,
    feedEntries = _g === void 0 ? [] : _g,
    perCapitaIncome = entity.perCapitaIncome,
    medianHouseholdIncome = entity.medianHouseholdIncome,
    _h = entity.impactStories,
    impactStories = _h === void 0 ? [] : _h;
  var totalGenderPopulation = populationMale + populationFemale;
  var percentageMale = totalGenderPopulation && populationMale ? "".concat((populationMale / totalGenderPopulation * 100).toFixed(1), "% M") : '';
  var percentageFemale = totalGenderPopulation && populationFemale ? "".concat((populationFemale / totalGenderPopulation * 100).toFixed(1), "% F") : '';
  var genderSplit = percentageMale && percentageFemale && "".concat(percentageFemale, " / ").concat(percentageMale);
  var geoDemoValues = (0, lodash_1.filter)([areaInSquareKm && {
    id: "area-in-square-km-value",
    value: (0, format_number_1.formatNumber)(areaInSquareKm),
    indicator: indicator_value_table_1.INDICATOR_AREA_IN_SQ_KM
  }, population && {
    id: "population",
    value: (0, format_number_1.formatNumber)(population),
    indicator: indicator_value_table_1.INDICATOR_POPULATION
  }, populationCity && {
    id: "population-city",
    value: (0, format_number_1.formatNumber)(populationCity),
    indicator: indicator_value_table_1.INDICATOR_POPULATION_CITY
  }, densityPerSquareKm && {
    id: "density",
    value: (0, format_number_1.formatNumber)(densityPerSquareKm),
    indicator: indicator_value_table_1.INDICATOR_DENSITY
  }]);
  var genderAgeValues = (0, lodash_1.filter)([genderSplit && {
    id: "gender-split",
    value: genderSplit,
    indicator: indicator_value_table_1.INDICATOR_GENDER_SPLIT
  }, medianAge && {
    id: "median-age",
    value: (0, format_number_1.formatNumber)(medianAge),
    indicator: indicator_value_table_1.INDICATOR_MEDIAN_AGE
  }, age0To19 && {
    id: "age-0-19",
    value: (0, format_number_1.formatNumber)(age0To19),
    indicator: indicator_value_table_1.INDICATOR_AGE_0_TO_19
  }, age20To49 && {
    id: "age-20-49",
    value: (0, format_number_1.formatNumber)(age20To49),
    indicator: indicator_value_table_1.INDICATOR_AGE_20_TO_49
  }, age50Plus && {
    id: "age-50-plus",
    value: (0, format_number_1.formatNumber)(age50Plus),
    indicator: indicator_value_table_1.INDICATOR_AGE_50_PLUS
  }]);
  var economyValues = (0, lodash_1.filter)([gdp && {
    id: "gdp",
    value: (0, format_number_1.formatNumber)(gdp),
    indicator: indicator_value_table_1.INDICATOR_GDP
  }, perCapitaIncome && {
    id: "per-capita-income",
    value: (0, format_number_1.formatNumber)(perCapitaIncome),
    indicator: indicator_value_table_1.INDICATOR_PER_CAPITA_INCOME
  }, medianHouseholdIncome && {
    id: "median-household-income",
    value: (0, format_number_1.formatNumber)(medianHouseholdIncome),
    indicator: indicator_value_table_1.INDICATOR_MEDIAN_HOUSEHOLD_INCOME
  }]);
  var hasCountry = !!country;
  var hasLinks = !!links.length;
  var hasQuotes = !!quotes.length;
  var hasImpactResults = !!impactResults.length;
  var hasNarratives = hasQuotes || hasImpactResults;
  var hasChapter = !!chapter;
  var hasStatistics = !!geoDemoValues.length || !!economyValues.length || !!genderAgeValues.length;
  var hasImpactStories = entities.ImpactStory && !!impactStories.length;
  var hasAside = asideHeader || asideFooter || hasCountry || hasLinks || hasChapter;
  return react_1.default.createElement(react_1.default.Fragment, null, banner, react_1.default.createElement(My.MainAside, {
    className: className,
    main: react_1.default.createElement(My.Main, null, mainHeader, react_1.default.createElement(My.Description, {
      entity: description,
      title: "About:"
    }), react_1.default.createElement(My.ListSection, {
      variant: 'large',
      rowComponent: file_asset_value_1.FileAssetValue,
      showDividers: true,
      title: "Related Files:",
      items: files,
      maxItems: 3
    }), hasStatistics && react_1.default.createElement(My.Section, {
      title: "Statistics:"
    }, react_1.default.createElement(My.Table, {
      indicatorCellLabel: "Geography and Demography",
      items: geoDemoValues
    }), react_1.default.createElement(My.Table, {
      indicatorCellLabel: "Gender and Age",
      items: genderAgeValues
    }), react_1.default.createElement(My.Table, {
      indicatorCellLabel: "Economy",
      items: economyValues
    })), hasNarratives && react_1.default.createElement(My.Section, {
      title: "Narratives:"
    }, hasQuotes && react_1.default.createElement(My.List, {
      rowComponent: quote_row_1.QuoteRow,
      showDescription: true,
      items: quotes
    }), hasImpactResults && react_1.default.createElement(My.List, {
      showDescription: true,
      namePath: "type.name",
      items: impactResults
    })), react_1.default.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: [!!organisations.length && react_1.default.createElement(My.ListSection, {
        maxItems: 3,
        items: organisations
      }), !!people.length && react_1.default.createElement(My.ListSection, {
        maxItems: 3,
        items: people
      })]
    }), react_1.default.createElement(My.ListSection, {
      showDividers: true,
      items: impactStories
    }), react_1.default.createElement(My.ListSection, {
      showDividers: true,
      items: feedEntries
    }), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, hasCountry && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.LinkValue, {
      entity: country
    })), react_1.default.createElement(My.ListSection, {
      useLinks: false,
      title: "Related:",
      maxItems: 4,
      items: links,
      rowComponent: link_value_1.LinkValue
    }), hasChapter && react_1.default.createElement(My.Section, {
      title: "{{CHAPTER}}:"
    }, react_1.default.createElement(My.LinkValue, {
      entity: chapter
    })), asideFooter)
  }));
};
exports.LocationDetailsLayout = LocationDetailsLayout;
exports.LocationDetailsLayout.defaultProps = exports.LocationDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25;